import React from "react";
import { useLocation, Navigate } from "react-router-dom";

/**
 * Protects a route by requiring authentication.
 * @param {object} props
 * @param {boolean} props.isAuthenticated - Whether the user is authenticated.
 * @param {React.ReactNode} props.children - The component(s) to render if authenticated.
 */

import { useAuth } from "./App";

export default function ProtectedRoute({ isAuthenticated, children }) {
  const location = useLocation();
  const { auth } = useAuth();
  const pathname =
    typeof location === "object" && location !== null
      ? location.pathname || ""
      : String(location || "/");

  // DEBUG: Log pathname and is_applicant for route debugging
  // console.log(
  //   "[ProtectedRoute] pathname:",
  //   pathname,
  //   "is_applicant:",
  //   auth?.user?.is_applicant
  // );
  if (!isAuthenticated) {
    let redirectPath = pathname + (location.search || "");
    if (redirectPath.startsWith("/signin")) redirectPath = "/";
    return (
      <Navigate
        to={`/signin?redirect=${encodeURIComponent(redirectPath)}`}
        replace
      />
    );
  }

  // Strict separation
  const isApplicant = !!auth?.user?.is_applicant;
  if (isApplicant && pathname.includes("/admin")) {
    return <Navigate to="/candidate" replace />;
  }
  if (!isApplicant && pathname.startsWith("/candidate")) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
